import React from 'react'
import styled from '@emotion/styled'
import { straitsXTheme } from '@xfers/design-system'
import { StraitsXLogo } from '@xfers/design-system/es/logos'
import { Info } from '@xfers/design-system/es/icons'

function MaintenancePage() {
  return (
    <Container>
      <Content>
        <LogoContainer>
          <StraitsXLogo width={200} height={28} />
        </LogoContainer>
        <CardContainer>
          <IconContainer>
            <Info style={{ color: straitsXTheme.brand.primary.emphasis }} width="32" height="32" />
          </IconContainer>
          <Header>We&apos;re Under Maintenance</Header>
          <Body>
            Our system is currently undergoing scheduled maintenance. Please check back again
            shortly. We apologize for any inconvenience caused.
          </Body>
          <Footer>
            If you need assistance, please contact{' '}
            <SupportLink href="mailto:support@straitsx.com">support@straitsx.com</SupportLink>
          </Footer>
        </CardContainer>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${straitsXTheme.brand.primary.background};
  -webkit-font-smoothing: antialiased;
  display: flex;
`

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`

const LogoContainer = styled.div`
  margin-bottom: 32px;
`

const CardContainer = styled.div`
  max-width: 480px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 48px 40px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
`

const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${straitsXTheme.brand.primary.background};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
`

const Header = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${straitsXTheme.brand.primary.default};
  margin-bottom: 12px;
`

const Body = styled.div`
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: ${straitsXTheme.neutral.text};
  margin-bottom: 24px;
`

const Footer = styled.div`
  border-top: 1px solid ${straitsXTheme.neutral.border};
  padding-top: 20px;
  font-size: 13px;
  color: ${straitsXTheme.neutral.text};
  text-align: center;
`

const SupportLink = styled.a`
  color: ${straitsXTheme.brand.primary.emphasis};
  text-decoration: none;
`

export default MaintenancePage
